<template>
  <div class="container">
    <h3 class="title">Czy w związku z tymi objawami,<br/> odbyła się już wizyta u specjalisty?</h3>
    <div class="btn-group">
      <button type="button" class="btn gray" :style="{ background: $color }" @click="btnHandler(false)">NIE</button>
      <button type="button" class="btn" :style="{ background: $color }" @click="btnHandler(true)">TAK</button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: "StepMedicalWasDoctor",
  methods: {
    ...mapMutations(['setUserData', 'setAssistanceStep']),
    btnHandler (WasDoctor) {
      this.setUserData({ WasDoctor: WasDoctor ? 'TAK' : 'NIE' })
      this.setAssistanceStep('additional')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/assistance_steps/StepMedicalWasDoctor.vue